/**
 * @fileoverview Input/output schemas for world-element-rare-detector-v3.
 *
 * This agent detects world elements using inferential extraction:
 * rules embedded in dialogue, sensory staging, biological details.
 *
 * Schema is identical to the core detector — both share the same
 * input/output contract and DetectorOutputSchema.
 */

import { z } from 'zod';
import { BaseFlowInputSchema } from '@/ai/agents/base-schema';
import { AGENT_SCHEMA_OBJECTS } from '@/ai/agents/prompt-variables';
import { DetectorOutputSchema } from '@/domains/world-building/schemas/world-element-detection';

// =============================================================================
// FLOW INPUT SCHEMA
// =============================================================================

/**
 * Full input for the agent flow.
 * genrePriorities and existingElements are pre-formatted strings
 * injected by the composite agent.
 */
export const InputSchema = BaseFlowInputSchema.extend({
  textInput: z.string().describe('The full text to analyze.'),
  genrePriorities: z.string().optional().describe(
    'Genre-informed priority guidance for element types. Formatted as readable text.'
  ),
  existingElements: z.string().optional().describe(
    'Names of already-extracted elements to avoid duplicates.'
  ),
}).merge(AGENT_SCHEMA_OBJECTS.loreContext.schema);

export type Input = z.infer<typeof InputSchema>;

// =============================================================================
// OUTPUT SCHEMA
// =============================================================================

export const OutputSchema = DetectorOutputSchema;
export type Output = z.infer<typeof OutputSchema>;
